"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Background = void 0;
exports.getStyle = getStyle;
exports.loadImage = loadImage;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _Background = require("./Background.styled");
var _logger = require("@studio/logger");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MAX_RETRIES = 3;
var RETRY_INTERVAL = 1000;
var Background = exports.Background = function Background(_ref) {
  var style = _ref.style,
    children = _ref.children,
    disableStageBorderRadius = _ref.disableStageBorderRadius,
    enableRetry = _ref.enableRetry;
  var el = (0, _react.useRef)(null);
  var styleToUse = getStyle(style, el.current && el.current.style);
  // eslint-disable-next-line no-unused-vars
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasBackgroundLoaded = _useState2[0],
    setHasBackgroundLoaded = _useState2[1];
  var isFirstLoad = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (enableRetry && isFirstLoad.current) {
      var backgroundImage = getBackgroundProp(styleToUse);
      var urlMatch = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.match(urlRegex);
      if (urlMatch) {
        var url = urlMatch[0];
        loadImage(0, url, setHasBackgroundLoaded);
      }
      isFirstLoad.current = false;
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Background.Wrapper, {
    ref: el,
    style: styleToUse,
    disableStageBorderRadius: disableStageBorderRadius
  }, children);
};
Background.propTypes = {
  style: _propTypes["default"].object,
  children: _propTypes["default"].element,
  disableStageBorderRadius: _propTypes.bool,
  enableRetry: _propTypes.bool
};
var urlRegex = new RegExp(/(https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/);

/**
 * This function gets a style object, but is careful not to update the `backgroundImage` style property unless the URL host + path (and not just the signature query param)
 *
 * @param {*} style
 * @param {*} prevStyle
 */
function getStyle(style, prevStyle) {
  if (!style || !prevStyle) return style;
  var backgroundProp = getBackgroundProp(style);
  var prevBackgroundProp = getBackgroundProp(prevStyle);
  // If there was not previously a background prop, return the new style
  if (!prevBackgroundProp) return style;
  var urlMatch = backgroundProp.match(urlRegex);
  var prevUrlMatch = prevBackgroundProp.match(urlRegex);
  // If either one of the new style objects doesn't have a background URL, just
  // return the NEW style object unmutated
  if (!urlMatch || !prevUrlMatch) return style;
  var url = new URL(urlMatch[0]);
  var prevUrl = new URL(prevUrlMatch[0]);

  // If the hostname, pathname or search don't match, return the NEW style
  // object unmutated. The search contains the url signature information
  // which means that if it is different we have a newly signed url.
  if (url.hostname !== prevUrl.hostname) return style;
  if (url.pathname !== prevUrl.pathname) return style;
  if (url.search !== prevUrl.search) return style;

  // TODO: consider checking the 'Expires' query arg in the prevUrl.searchParams
  //  (ref: https://developer.mozilla.org/en-US/docs/Web/API/URL/searchParams)
  //  to see if it is expired

  return _objectSpread(_objectSpread({}, style), {}, {
    backgroundImage: "url(\"".concat(prevUrl, "\") !important")
  });
}
function getBackgroundProp(style) {
  return style.backgroundImage || style.background || '';
}
function loadImage(retryCount, url, setHasBackgroundLoadedRef) {
  var img = new Image();
  img.onload = function () {
    (0, _logger.sendToDatadog)('Background', {
      url: url
    }, 'Background Image loaded successfully', false);
    setHasBackgroundLoadedRef(true);
  };
  img.onerror = function () {
    (0, _logger.sendToDatadog)('Background', {
      url: url
    }, "Attempt #".concat(retryCount, " Failed to load Background Image"), false);
    if (retryCount + 1 < MAX_RETRIES) {
      setHasBackgroundLoadedRef(false);
      setTimeout(function () {
        return loadImage(retryCount + 1, url, setHasBackgroundLoadedRef);
      }, RETRY_INTERVAL);
    } else {
      (0, _logger.sendToDatadog)('Background', {
        url: url
      }, 'Max Attempts reached to load background image', true);
      setHasBackgroundLoadedRef(false);
    }
  };
  img.src = url;
}